import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { ICharacterEffect } from '../../../../../../../../api/types/character'
import {
  characterEffectsQueryKey,
  queryCharacterEffects,
} from '../../../../../../../../api/queries'
import { ErrorHandler } from '../../../../../../../../components/ErrorHandler/ErrorHandler'
import { fromAxiosError } from '../../../../../../../../context/GlobalError'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  FormControlLabel,
  List,
  Switch,
  Theme,
  Tooltip,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { createStyles, makeStyles } from '@mui/styles'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { Effect } from '../../../../../../../../components/Effect/Effect'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleBackground: {
      backgroundColor: theme.palette.mode === 'dark' ? '#313131' : '#d0d0d0',
    },
    mr4: {
      marginRight: '4px',
    },
  })
)

export const CharacterEffects: React.FC<{ char_id: number }> = ({ char_id }) => {
  const classes = useStyles()
  const {
    isLoading: isLoading,
    data: effects,
    error,
  } = useQuery<ICharacterEffect[]>(characterEffectsQueryKey(char_id), () =>
    queryCharacterEffects(char_id)
  )

  const [timedOnly, setTimedOnly] = useState(true)

  return (
    <>
      <ErrorHandler loading={isLoading} error={fromAxiosError(error)}>
        <List>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <FormControlLabel
              sx={{ marginRight: '8px' }}
              control={
                <Switch
                  color="primary"
                  checked={timedOnly}
                  onChange={e => setTimedOnly(e.target.checked)}
                />
              }
              label="Pokaż tylko efekty czasowe"
              labelPlacement="start"
            />
          </Box>
          {effects &&
            effects
              .filter(e => (timedOnly ? e.effect.timed : true))
              .map(character_effect => (
                <Accordion elevation={0}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className={classes.titleBackground}
                  >
                    <Box
                      sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Typography>{character_effect.name}</Typography>
                      <Box>
                        <>
                          {character_effect.time_left >= 0 && (
                            <Tooltip title={'Pozostały czas efektu'}>
                              <Chip
                                className={classes.mr4}
                                icon={<AccessTimeIcon />}
                                label={character_effect.time_left}
                                variant="outlined"
                              />
                            </Tooltip>
                          )}
                        </>
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Effect effect={character_effect.effect} showTimedBanner={false} />
                  </AccordionDetails>
                </Accordion>
              ))}
        </List>
      </ErrorHandler>
    </>
  )
}
